// SessionTimeoutMessage.tsx
import React, { useEffect } from 'react';
import Keycloak from 'keycloak-js';
import { ConfirmModal } from './ConfirmPopup';
import { useNavigate } from 'react-router-dom';
interface SessionTimeoutMessageProps {
  onLogout: () => void;
  keycloak: Keycloak | undefined;
}

const SessionTimeoutMessage: React.FC<SessionTimeoutMessageProps> = ({ onLogout, keycloak }) => {
  
  useEffect(()=>{
    console.log("session has timed out");
    //keycloak!.logout();
  },[])

const navigate = useNavigate();

const handleConfirm = () => {
  window.location.href = '/home';
  // window.location.href = '/';
  // navigate(-1);
  // alert("home");
}

// const handleCancel = () => {
//    keycloak?.logout();
// }

  return (
    <div className="session-timeout-message">
      {/* <p>Your session has timed out. Please log in again.</p> */}
      <ConfirmModal message={'You have been inactive for a while. Do you want to continue exploring Marketplace ?'} handleConfirm={handleConfirm} handleCancel={onLogout} remark={""} />
      {/* <button onClick={onLogout}>Log Out</button> */}
    </div>
  );
};

export default SessionTimeoutMessage;
